export const SETUP_ACCOUNT_PATH = 'setup-account'
